<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="序列号"><el-input v-model="query.serialNo" size="small" clearable style="width:180px" /></el-form-item>
      <el-form-item label="物料编码"><el-input v-model="query.materialCode" size="small" clearable style="width:160px" /></el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" size="small" clearable placeholder="全部" style="width:120px">
          <el-option label="在库" value="0" /><el-option label="已出库" value="1" /><el-option label="占用" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('inventory:serial:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button size="small" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="rows" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column prop="serialNo" label="序列号" min-width="160" />
      <el-table-column prop="materialCode" label="物料编码" min-width="130" />
      <el-table-column prop="materialName" label="物料名称" min-width="150" />
      <el-table-column prop="status" label="状态" width="90">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === '0'" size="small">在库</el-tag>
          <el-tag v-else-if="scope.row.status === '1'" type="info" size="small">已出库</el-tag>
          <el-tag v-else type="warning" size="small">占用</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="wareHouseName" label="库位" min-width="160" />
      <el-table-column prop="batchNo" label="批号" min-width="100" />
      <el-table-column prop="createDate" label="创建日期" width="120" />
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[20, 50, 100]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="v => { pageSize = v; pageIndex = 1; load() }" @current-change="v => { pageIndex = v; load() }" />
  </div>
</template>
<script>
import request from '../../api/request'
import { authMixin } from './inventoryShared'
export default {
  name: 'Serial',
  mixins: [authMixin],
  data() { return { query: { serialNo: '', materialCode: '', status: '' }, rows: [], pageIndex: 1, pageSize: 20, total: 0, loading: false } },
  created() { this.load() },
  methods: {
    search() { this.pageIndex = 1; this.load() },
    resetQuery() { this.query = { serialNo: '', materialCode: '', status: '' }; this.search() },
    load() {
      this.loading = true
      request.get('/inventory/serial/list', { params: { serialNo: this.query.serialNo, materialCode: this.query.materialCode, status: this.query.status, currentPage: this.pageIndex, pageSize: this.pageSize } })
        .then(res => {
          const data = res.data || {}
          this.rows = data.list || []
          this.total = data.totalCount || 0
        }).catch(() => { this.rows = []; this.total = 0 }).finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
.title-actions { float: right; margin-right: 28px; }
.line-tools { margin-bottom: 10px; }
.cards { margin-bottom: 12px; }
.card-num { font-size: 28px; font-weight: 600; margin-top: 8px; }
</style>
